<template>
    <div class="instructor-quarter-grade">
        <PreLoader v-if="isLoading"/>
        <div v-html="$t('quarter_grade')" class="titleSchedule"/>
        <v-btn-toggle v-model="toggle_exclusive" tile group style="color: #2F80ED">
            <v-btn dense outlined v-for="item in childrenData" :key="item.id"
                   style="padding: 30px 10px; border-radius: 8px" @click="getScheduleByChildren(item.studentId)">
                <div style="display: flex; flex-direction: column">
                    <div>{{item.studentName}} {{item.studentSurname}}</div>
                </div>
            </v-btn>
        </v-btn-toggle>
        <div class="instructor-quarter-grade__body">
            <table class="instructor-quarter-grade__table" v-if="studentQuarterGrades.length">
                <thead>
                <tr>
                    <th style="font-weight: 600">{{ $t('course') }}</th>
                    <th v-for="(quarter, i) in schoolQuarters" :key="i">
                        <span class="blue">{{quarterTitle[quarter.semester]}} - {{ $t('quarter') }}</span>
                    </th>
                    <th v-if="showGosExam"><span class="blue">{{ $t('stateExam') }}</span></th>
                    <th><span class="blue">{{ $t('finalExam') }}</span></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(student, i) in studentQuarterGrades" :key="i">
                    <td class="full-name">{{student.courseTitle}}</td>
                    <td v-for="(quarter, i) in schoolQuarters" :key="i">
                        <div v-if="getQuarterGrade(quarter, student.grades)">
                            {{ getQuarterGrade(quarter, student.grades).mark }}
                        </div>
                        <div v-else></div>
                    </td>
                    <td v-if="showGosExam"></td>
                    <td>{{ getFinalGrade(student).mark }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import PreLoader from '@/components/preloader/PreLoader.vue'
import StudentDataService from '@/_services/student-data.service'
import ParentService from '@/_services/parent.service'
import { QuarterService } from '@/_services/quarter.service'
import { ChronicleService } from '@/_services/chronicle.service'
const quarterService = new QuarterService()
const chronicleService = new ChronicleService()

export default {
  name: 'QuarterGrade',
  components: { PreLoader },
  data () {
    return {
      toggle_exclusive: null,
      selectedChildren: '',
      text: '',
      childrenData: [],
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      quarterTitle: {
        1: 'I',
        2: 'II',
        3: 'III',
        4: 'IV'
      },
      requestObj: {
        classId: '',
        courseId: ''
      },
      sendQuarterGradeObj: {
        chronicleId: 0,
        classId: 0,
        instructorId: 0,
        students: []
      },
      schoolQuarters: [],
      instructorCourses: [],
      allCourses: [],
      studentQuarterGrades: [],
      isLoading: false,
      showGosExam: false,
      finalGrades: [],
      yearId: ''
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },

  created () {
    this.isLoading = true
    this.getChildren()
    this.getCurrentYearId()
    this.sendQuarterGradeObj.instructorId = this.userProfile.personId
  },

  methods: {
    getCurrentYearId () {
      chronicleService.getCurrentId().then((res) => {
        this.sendQuarterGradeObj.chronicleId = res.id
      })
    },

    getChildren () {
      ParentService.getAllChildren(this.userProfile.personId).then((res) => {
        this.isLoading = false
        if (res._embedded) {
          this.childrenData = res._embedded.studentParentResourceList
        } else {
          this.childrenData = []
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    getScheduleByChildren (id) {
      this.selectedChildren = id
      this.fetchStudentQuarterGrades()
    },

    fetchStudentQuarterGrades () {
      this.studentQuarterGrades = []
      this.sendQuarterGradeObj.students = []
      this.isLoading = true
      StudentDataService.getGradeMark(
        this.selectedChildren,
        this.sendQuarterGradeObj.chronicleId
      ).then((res) => {
        this.studentQuarterGrades = res
        this.finalGrades = []
        this.studentQuarterGrades.forEach((el) => {
          this.finalGrades.push(
            {
              m2mStudentCourseId: el.m2mStudentCourseId,
              mark: this.calculateFinalGrade(el)
            }
          )
        })
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    getQuarterGrade (currentQuarter, studentQuarterGrades) {
      return studentQuarterGrades.find((quarterGrade) => quarterGrade.quarterId === currentQuarter.id)
    },

    calculateFinalGrade (student) {
      const newMarks = this.sendQuarterGradeObj.students
        .filter((el) => el.m2mStudentCourseId === student.m2mStudentCourseId)
      const quarterIds = newMarks.map((el) => { return el.quarterId })
      const currentMarks = student.grades.filter((el) => !(quarterIds.includes(el.quarterId)))
      const sum = newMarks.reduce((r, a) => r + Number(a.mark), 0) + currentMarks.reduce((r, a) => r + Number(a.mark), 0)
      const length = newMarks.length + currentMarks.length
      return sum > 20 || sum === 0 || length !== 4 ? undefined : (sum / (newMarks.length + currentMarks.length)).toFixed()
    },

    getFinalGrade (student) {
      return this.finalGrades.find(el => el.m2mStudentCourseId === student.m2mStudentCourseId)
    }
  }
}
</script>

<style lang="scss" scoped>
td{
    vertical-align: middle;
}

.titleSchedule{
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 20px;
}
.instructor-quarter-grade {
    padding: 25px;
    font-family: Helvetica, sans-serif;

    .saveGrade {
        position: fixed;
        bottom: 15px;
        width: 100%;
    }

    .v-select-item {
        margin: 25px 0;
    }

    &__body {
        margin: 20px 0 45px;
    }

    &__table {
        background: #FFFFFF;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
        border-radius: 4px;

        th, td {
            &:not(:first-child) {
                max-width: 150px;
                overflow: hidden;
                white-space: nowrap;
            }

            &:nth-child(2), &:nth-child(3) {
                background: rgba(74, 39, 243, 0.1);
                border-right: 10px solid #fff;
                width: 150px;
            }

            &:nth-child(4) {
                background: rgba(0, 217, 95, 0.1);
                border-right: 10px solid #fff;
                width: 150px;
            }
            &:nth-child(5) {
                background: rgba(0, 217, 95, 0.1);
                border-right: 10px solid #fff;
                width: 150px;
            }
            &:nth-child(6) {
                border-right: 10px solid #fff;
                background: rgb(6 205 198 / 10%);
                width: 150px;
            }
            &:nth-child(7) {
                background: #ccd6ff;
                width: 150px;
            }
        }

        thead {
            tr {
                border-radius: 4px;
                height: 40px;

                th:first-child {
                    font-family: Open Sans, sans-serif;
                    font-size: 14px;
                    line-height: 119%;
                    text-align: center;
                    color: #707683;
                }

                th {
                    span {
                        border-radius: 5px;
                        height: 40px;
                        font-size: 14px;
                        line-height: 14px;
                        font-weight: bold;

                        &.blue {
                            background: #1976D2;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            letter-spacing: 0.01em;
                            color: #FFFFFF;
                        }

                        &.green {
                            background: #00D95F;
                        }
                    }
                }
            }
        }

        tr {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            height: 54px;

            td:not(:first-child) {
                text-align: center;
                font-size: 18px;
                line-height: 21px;
                letter-spacing: 0.01em;
                color: #323C47;
            }

            .full-name {
                min-width: 250px;
                padding: 0 25px;
                font-size: 14px;
                line-height: 16px;
                letter-spacing: 0.01em;
                color: #323C47;
            }
        }

        tbody {
            tr {
                &:hover {
                    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
                }
            }
        }
    }
}
</style>
